import {z} from 'zod';

export const PhoneNumber = z.object({
  type: z.enum(['PRIVATE', 'BUSINESS', 'NONE']),
  prefix: z.string(),
  number: z.string(),
});

export type PhoneNumber = z.infer<typeof PhoneNumber>;
